import { useIntl } from 'react-intl';

import caas from '../../../assets/images/caas.svg';
import BreadCrumb from '../../../components/BreadCrumb';
import useMarkdownFile from '../../../hooks/useMarkdownFile';
import caasSpecificationDe from '../../../markdowns/Caas/specification.de.md';
import caasSpecificationEn from '../../../markdowns/Caas/specification.md';
import SpecificationContent from '../SpecificationContent';

const CaasSpecification = () => {
  const intl = useIntl();
  const caasSpecification = intl.locale === 'de' ? caasSpecificationDe : caasSpecificationEn;
  const { markdownContent } = useMarkdownFile(caasSpecification);

  return (
    <SpecificationContent
      logo={{
        src: caas,
        alt: intl.formatMessage({ id: 'caasLogoAlt' }),
      }}
      content={
        <>
          <BreadCrumb
            items={[
              {
                href: '/',
                text: intl.formatMessage({ id: 'title' }),
              },
              {
                href: '#',
                text: intl.formatMessage({ id: 'caas' }),
              },
            ]}
          />
          {markdownContent}
        </>
      }
    />
  );
};

export default CaasSpecification;
